import * as React from 'react'

import { AlertDialog, Button, Flex } from 'components/ds'

type Props = {
  open: boolean
  contactCount: number
  /** Omitted for a global unsubscribe, which covers every email we send. */
  listName?: string
  onConfirm: () => void
  onClose: () => void
}

/** Confirmation for unsubscribing the selected contacts. */
const UnsubscribeConfirmation = ({
  open,
  contactCount,
  listName,
  onConfirm,
  onClose,
}: Props): React.ReactNode => {
  const singleContact = contactCount === 1
  const who = singleContact ? 'this user' : `these ${contactCount} users`
  let from = 'all emails'

  if (listName !== undefined) {
    from = listName ? `“${listName}”` : 'this mailing list'
  }

  return (
    <AlertDialog.Root
      open={open}
      onOpenChange={nowOpen => {
        if (!nowOpen) onClose()
      }}
    >
      <AlertDialog.Content maxWidth="450px">
        <AlertDialog.Title>
          {singleContact ? 'Unsubscribe user' : 'Unsubscribe users'}
        </AlertDialog.Title>
        <AlertDialog.Description size="2">
          {`Are you sure you want to unsubscribe ${who} from ${from}?`}
        </AlertDialog.Description>
        <Flex gap="3" mt="4" justify="end">
          <AlertDialog.Cancel>
            <Button variant="soft" color="gray">
              Cancel
            </Button>
          </AlertDialog.Cancel>
          <AlertDialog.Action>
            <Button variant="solid" color="red" onClick={onConfirm}>
              Unsubscribe
            </Button>
          </AlertDialog.Action>
        </Flex>
      </AlertDialog.Content>
    </AlertDialog.Root>
  )
}

export default UnsubscribeConfirmation
